import { render, staticRenderFns } from "./LeftColFondo.vue?vue&type=template&id=5102b2e4&scoped=true"
import script from "./LeftColFondo.vue?vue&type=script&lang=js"
export * from "./LeftColFondo.vue?vue&type=script&lang=js"
import style0 from "./LeftColFondo.vue?vue&type=style&index=0&id=5102b2e4&prod&scoped=true&lang=css"
import style1 from "./LeftColFondo.vue?vue&type=style&index=1&id=5102b2e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5102b2e4",
  null
  
)

export default component.exports